import styled from 'styled-components';

import {Switch} from "@chakra-ui/react";
import {useStoreProfile} from "../../../store";
import FormContainer from "../../../components/form_container";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";
import {themecolors} from "../../../utils/themecolors";
import {useActions} from "../../../app_context";
import useFeedback from "../../../utils/use_feedback";
import {useSaveSettings} from "../../../api/user";

const SwitchHeading = styled.div``;
const SwitchDescription = styled.div``;
const SwitchContainer = styled.div``
const SwitchText = styled.div``;
const SwitchItem = styled.div``;

const NotificationsSettings = styled(({className}) => {

    const actions = useActions();
    const settings = useStoreProfile();
    const {error, feedbackCh} = useFeedback();
    const saveSettings = useSaveSettings(feedbackCh);
    const apply = async (changes) => {
        actions.settingsChanged(changes);
        await saveSettings(settings);
    };

    return (
        <>
            <FixedTopBar back title="Notifications" border={false}/>
            <WhiteMain className={className}>
                <FormContainer>

                    <SwitchContainer>
                        <SwitchText>
                            <SwitchHeading>Username Pings</SwitchHeading>
                            <SwitchDescription>
                                You'll receive a notification when another user tags you.
                            </SwitchDescription>
                        </SwitchText>
                        <SwitchItem>
                            <Switch isChecked={settings.username_pings}
                                    onChange={(value) => apply({username_pings: !settings.username_pings})}/>
                        </SwitchItem>
                    </SwitchContainer>

                    <SwitchContainer>
                        <SwitchText>
                            <SwitchHeading>Comment Replies</SwitchHeading>
                            <SwitchDescription>
                                You'll receive a notification when your comment gets a reply.
                            </SwitchDescription>
                        </SwitchText>
                        <SwitchItem>
                            <Switch isChecked={settings.notify_comments}
                                    onChange={(value) => apply({notify_comments: !settings.notify_comments})}/>
                        </SwitchItem>
                    </SwitchContainer>

                </FormContainer>
            </WhiteMain>
        </>
    );
})`
  ${FormContainer} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
    padding: 16px 20px;
  }

  ${SwitchDescription} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : 'rgb(89, 96, 104)'};
    font-size: 13px;
  }

  ${SwitchContainer} {
    width: 450px;
    max-width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 16px;
  }

  ${SwitchHeading} {
    font-weight: 600;
    font-size: 14px;
  }

  ${SwitchItem} {
    margin-left: auto;
  }
`;

export default NotificationsSettings;
